/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: carousel.js
 */
$.namespace("SCS.carousel");

/**
 * Initialize all carousels found within a specific context or the body if no context is specified
 */
SCS.carousel.initCarousels = function(context) {
	context = context && context.closest && context.closest('body').length ? context : null;
	if(context){
		context.find('.carouselContainer').each(SCS.carousel.initializeCarousel);
	}
};

/**
 * Initialize a single carousel
 * @param carousel Carousel object
 */
SCS.carousel.initializeCarousel = function() {
	var carouselContainer = $(this);

	if(carouselContainer.is('.manual-init')) {
		return;
	}

	if (carouselContainer.data('carousel-initialized')) {
		return;
	}
	carouselContainer.data('carousel-initialized', true);

	var buttons = carouselContainer.find('.carousel-prev, .carousel-next'),
		labels = carouselContainer.find('.label-next, .label-prev'),
        controls = carouselContainer.find('.carousel-control'),
		initCallback = null;

    if($('.carouselContainer').data('controls')) {
        controls.hide();
    } else {
        controls.show();
    }

	if (carouselContainer.hasClass('thumbnailsCarouselContainer')) {
		SCS.carousel.activateVideo(carouselContainer.find('.items .item:first').show());
		initCallback = SCS.carousel.initThumbnailsCarouselCallback;
	} else {
		carouselContainer.find('ul.carousel-list > li').show().width(carouselContainer.closest('.carouselContainer').width());
		initCallback = SCS.carousel.initCarouselCallback;
	}

	carouselContainer.scCarousel({
		onAfterInit: function (instance) {
			// restore deeplink to this carousel-index from URL hash
			var deeplinkPosition = window.SCS.HashDeepLink.get('carousel');
			if (deeplinkPosition && carouselContainer.attr('data-deeplinks-enabled') === 'true') {
				instance.slideTo(parseFloat(deeplinkPosition, 10));
			}

            // sliding
      		var self = instance,
                $slideLink = $('.carousel a.carousel-slide-to-link');

            $slideLink.click(function() {
        	   	self.slideTo($(this).data('slideto'));
            });


			initCallback.apply(this, arguments);
		},
		onBeforeAnimation: function (instance, outElement, inElement) {
			buttons.hide();
			SCS.carousel.deactivateVideos(carouselContainer);
		},
		onAfterAnimation: function (instance, outElement, inElement) {
			buttons.show();
			SCS.carousel.activateVideo($(inElement));

			// set deeplink to this carousel-index in URL hash
			if (carouselContainer.attr('data-deeplinks-enabled') === 'true') {
				window.SCS.HashDeepLink.set('carousel', instance.position);
			}
		}
	});
	var mouseenter = false;
	labels.show();

	carouselContainer
		.mouseenter(function () {
			buttons.show();
			mouseenter = true;
		})
		.mouseleave(function () {
			mouseenter = false;
			setTimeout(function() {
				if(!mouseenter) {
					buttons.hide();
					labels.show();
				}
			}, 300);
		});
};

/**
 * Initializations after the CATALOGUE-carousel is ready
 * @param carousel Carousel object
 */
var imageLoaded = require('lib/util/helpers').imageLoaded;
SCS.carousel.initCarouselCallback = function(carousel) {

	var images = [];
	carousel.listItems.each(function () {
		$(this).find('img').each(function(i, img) {
			images.push(imageLoaded(img));
		});
	});
	Promise.all(images).then(function() {
		SCS.carousel.adjustArrowNavigationPosition(carousel);
	});

	SCS.carousel.adjustArrowNavigationPosition(carousel);

	var duration = carousel.container.find('.carousel-clip').data('duration');
	if (duration) {
		var updateTimerCallback = function (timer) {
				if (!timer) {
					clearTimeout(carousel.container.data('autoSlideTimeout'));
				}
				carousel.container.data('autoSlideTimeout', timer);
			},
			start = function () {
				SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
			},
			stop = function () {
				updateTimerCallback(null);
			},
			$hoverElem = carousel.container.find('.carousel-clip').one("mousemove", function() {
				// handle case when mouse is already over the stage after page load
				if ($hoverElem.is(":hover")) {
					stop();
				}
			})
				.mouseenter(stop)
				.mouseover(stop)
				.mouseleave(start);
		start();
	}

	SCS.carousel.circleNavigationInit(carousel);
};

/**
 * @param carousel the carousel to be rotated
 * @param duration rotation-duration in sec
 * @param updateTimerCallback Callback to update timer. This is required to allow to place stage auto rotate carousel and one additional in the content.
 */
SCS.carousel.autoSlide = function(carousel, duration, updateTimerCallback) {
	updateTimerCallback(null);
	var timer = setTimeout(function() {
		var active = carousel.pagingItems.filter('.selected').index();
		if (carousel.stepSize) {
			carousel.showNext(true);
		} else {
			var next = (active + 1 === carousel.pagingItems.length) ? 0 : active + 1;
			carousel.pagingItems.blur().eq(next).click();
		}
		SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
	}, duration * 1000);
	updateTimerCallback(timer);
};

/**
 * Initializations after the THUMBNAIL-carousel is ready
 * @param carousel Carousel object
 */
SCS.carousel.initThumbnailsCarouselCallback = function(carousel) {
	carousel.container.find('.carousel-item').width(carousel.container.width());
	SCS.carousel.overlayThumbnailNavigationInit(carousel);
	SCS.carousel.thumbnailNavigationInit(carousel);
};

/**
 * Paging / Circle-navigation
 * @param carousel Carousel object
 */
SCS.carousel.circleNavigationInit = function(carousel) {
	/* todo: why is this done with JS instead of CSS? */
	var pagingContainer = carousel.container.find('.carousel-control');
	if (pagingContainer.is('.stage .normalCarouselContainer .carousel-control')) {
		pagingContainer.css('margin-left', '-' + Math.round(pagingContainer.width() / 2) + 'px');
	}
};

/**
 * Show / hide overlayed thumbnails
 * @param carousel Carousel object
 */
SCS.carousel.overlayThumbnailNavigationInit = function(carousel) {
	if (carousel.container.closest('.stage').length === 0) {
		// abort: we don't have the overlay navigation setting
		return;
	}
	var thumbnails = carousel.container.find('.thumbnailsCarousel');
	var timeoutId;
	carousel.container
		.mouseenter(function() {
			window.clearTimeout(timeoutId);
			thumbnails.slideDown();
		})
		.mouseleave(function() {
			timeoutId = window.setTimeout(function() {
				thumbnails.slideUp();
			}, 200);
		});
	// initially display thumbnails and hide them after 5 seconds
	thumbnails.slideDown();
	timeoutId = window.setTimeout(function() {
		thumbnails.slideUp();
	}, 5000);
};

/**
 * Thumbnail-navigation
 * @param carousel Carousel object
 */
SCS.carousel.thumbnailNavigationInit = function(carousel) {
	var container = carousel.container,
		$carouselYouTube = container.html().indexOf('youtube'),
		linkItems = container.find('a.carousel-link');

	linkItems
		.each(function (i) {
			$(this).data('index', i);
		})
		.on('click', function(e) {
			e.preventDefault();
			var $this = $(this);

			// do nothing if the clicked item is a placeholder (placeholders are needed for correct styling)
			if ($this.is('.placeholder')) {
				return;
			}

			// hide all items and stop all videos
			var allItems = container.find('.items .item');
			SCS.carousel.deactivateVideos(allItems);

			// Check for YouTube video
			if ($carouselYouTube != '-1') {
				allItems.addClass('useVisibility', 1000);
			} else {
				allItems.hide();
			}

			// display the new item, show text and start video if text or video is present in the current item
			var newItem = allItems.eq($this.data('index')).removeClass('useVisibility').show();
			if (container.closest('.videoWithText').length) {
				var text = newItem.find('.videoText').html();
				newItem.closest('.col_two').find('.two').html(text);
			}

			SCS.carousel.activateVideo(newItem, $carouselYouTube);

			// mark clicked item as active
			$this.closest('ul').find('a.selected').removeClass('selected');
			$this.addClass('selected');

			// set deeplink to this item-index in URL hash
			if (container.attr('data-deeplinks-enabled') === 'true') {
				window.SCS.HashDeepLink.set('carousel-thumbnail', linkItems.index($this));
			}
		});

	// initially show the first item OR restore deeplink to item from URL hash
	var deeplinkPosition = window.SCS.HashDeepLink.get('carousel-thumbnail'),
		initialActiveItem = linkItems.eq((deeplinkPosition && container.attr('data-deeplinks-enabled') === 'true') ? deeplinkPosition : 0);
	initialActiveItem.trigger('click');
};

SCS.carousel.deepLinks = function() {
    // initially show the first item OR restore deeplink to item from URL hash
    var deeplinkPosition = window.SCS.HashDeepLink.get('carousel-thumbnail');
        //initialActiveItem = linkItems.eq((deeplinkPosition && container.attr('data-deeplinks-enabled') === 'true') ? deeplinkPosition : 0);
        console.log("Informations about deepLinks");
        console.log(deeplinkPosition);
    //initialActiveItem.trigger('click');
}

/**
 * Stop playing all videos
 * @param item jQuery-object container to search for videos (in any depth, not just children)
 */
SCS.carousel.deactivateVideos = function(item) {
	item.find('.scs-media-player').each(function() {
		var itm = $(this);
		var player = itm.mediaPlayer();
		if(itm.data('wasPlaying') === null) {
			itm.data('wasPlaying', player.info.state.playing);
		}
		player.callbacks.playPause(false);
	});

	item.find('.modBrightcoveVideo').each(function() {
		var itm = $(this);
		var player = itm.data("brightcove-api");
		if(!player)
			return;
		if(itm.data('wasPlaying') === null) {
			itm.data('wasPlaying', player.isPlaying());
		}
		player.pause();
	});

	return item;
};

/**
 * Start playing a single video
 * @param item jQuery-object container to search for videos (in any depth, not just children)
 */
SCS.carousel.activateVideo = function(item, youtube) {
	var itm = item.find('.scs-media-player:first');
	var player;
	if(itm.mediaPlayer && (player = itm.mediaPlayer())) {
		if (player.controller) {
			player.controller.recalc();
		}

		if (youtube == '-1') {
			player.callbacks.playPause(itm.data('wasPlaying') === true);
			itm.data('wasPlaying', null);
		}
	}

	itm = item.find('.modBrightcoveVideo:first');
	if(player = itm.data("brightcove-api")) {
		if(!player)
			return;
		if (itm.data('wasPlaying') === true) {
			player.play();
		}
		itm.data('wasPlaying', null);
	}


	return item;
};

/**
 * Adjust position of left / right navigation buttons
 * @param carousel Carousel object
 */
SCS.carousel.adjustArrowNavigationPosition = function(carousel) {
	var container = carousel.container;
	var listTop = carousel.clip.position().top;
	var maxHeight = 0;
	carousel.listItems.each(function () {
		maxHeight = Math.max(maxHeight, $(this).outerHeight());
	});

	// if content is not yet loaded, please redo it again, because height < 20 is wrong for sure.
	if(maxHeight < 20 && carousel.listItems.length > 0) {
		setTimeout(function() { SCS.carousel.adjustArrowNavigationPosition(carousel); }, 200);
	} else if(maxHeight > 0) {
		if (carousel.container.hasClass('smart-arrows')) {
			var $window = $(window);
			$window.scroll(function () {
				scrollTop = $window.scrollTop();
				var vpHeight = $window.height(),
				    listTop = carousel.clip.position().top,
				    contHeight = carousel.clip.height(),
				    listOffTop = carousel.clip.offset().top,
				    buttonHeight = carousel.prevButton.height();
				var position = Math.round(listTop) + Math.round((maxHeight - buttonHeight) / 2);
				position = Math.max(position, scrollTop - listOffTop + buttonHeight);
				position = Math.min(position, contHeight - buttonHeight);
				// position is outside (below) the viewport
				if (listOffTop + position > scrollTop + vpHeight - buttonHeight) {
					position = scrollTop + vpHeight - buttonHeight - listOffTop;
					if (position < buttonHeight) position = buttonHeight;
				}
				carousel.prevButton.add(carousel.nextButton).css({
					'top': position + 'px'
				});
			});
		} else {
			carousel.prevButton.add(carousel.nextButton).css({
				'top': Math.round(listTop) + Math.round((maxHeight - carousel.prevButton.height()) / 2) + 'px'
			});
		}
	}
};

// Initialize carousels on dom-ready and/or jquery-load
SCS.ensure(SCS.carousel.initCarousels, 'body, .ui-tabs-panel, .modTabNavigationContent, .modLazyContainer');

// Update carousels when elements have been shown
$(document).on('element-shown', function(event, el) {
	el.find(':data(scCarousel)').each(function() {
		var $carouselContainer = $(this),
			carousel = $carouselContainer.data('scCarousel');

		if(carousel.updateNavigationWidth) {
			carousel.updateNavigationWidth();
		}

		if ($carouselContainer.hasClass('normalCarouselContainer')) {
			carousel.listItems.width(carousel.listItemWidth);
		}

		SCS.carousel.adjustArrowNavigationPosition(carousel);

		if ($carouselContainer.hasClass('catalogueCarouselContainer')) {
			carousel.listItems.width(carousel.listItemWidth);
			$catalogueCarouselImages = $('.scs-boxmovingproductteaser-image img', $carouselContainer);
			catalogueCarouselImagesNo = $catalogueCarouselImages.length;
			$catalogueCarouselImages.each(function(index) {
				$productTeaserImage = $(this);
				if (this.complete || /*for IE 10-*/ $productTeaserImage.height() > 0) {
					++index;
				} else {
					$productTeaserImage.on('load', function() {
						++index;
					});
				}

				if (catalogueCarouselImagesNo === index) {
					SCS.portal.synchronizeTeaserHeights('.carouselContainer', '.scs-boxmovingproductteaser', el);
				}
			});
		}
		// Check if it was opened before
		if ($carouselContainer.css('opacity') === '0') {
			$carouselContainer.css('opacity', 1);
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/carousel.js
// module id = 77
// module chunks = 0